import { render, staticRenderFns } from "./JNav.vue?vue&type=template&id=533e8031&scoped=true&"
import script from "./JNav.vue?vue&type=script&lang=js&"
export * from "./JNav.vue?vue&type=script&lang=js&"
import style0 from "./JNav.vue?vue&type=style&index=0&id=533e8031&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e8031",
  null
  
)

export default component.exports